<template>

    <div>
        <data-row title="Full Name">
            <span class="is-clickable" @click="$copyText(user.first_name + ' ' + user.last_name)">{{ user.first_name }} {{ user.last_name }}</span>
        </data-row>
        <data-row title="Maiden Name"><span class="is-clickable" @click="$copyText(user.maiden_name)">{{ user.maiden_name }}</span></data-row>
        <data-row title="E-Mail Address"><span class="is-clickable" @click="$copyText(user.email)">{{ user.email }}</span></data-row>
        <data-row title="Alt E-Mail"><span class="is-clickable" @click="$copyText(user.email_2)">{{ user.email_2 }}</span></data-row>
        <data-row title="Home Phone"><span class="is-clickable" @click="$copyText(user.phone)">{{ user.phone | tel }}</span></data-row>
        <data-row title="Work Phone"><span class="is-clickable" @click="$copyText(user.phone_2)">{{ user.phone_2 | tel }}</span></data-row>
        <data-row title="Address">
            <div class="is-clickable" @click="$copyText(user.address + ((user.address_2)?', '+user.address_2:', ') + user.city + ', ' + user.state + ' ' + user.zip)">
                <div>{{ user.address }}</div>
                <div v-if="user.address_2">{{ user.address_2 }}</div>
                <div>{{ user.city }}, {{ user.state }} &nbsp;{{ user.zip }}</div>
            </div>
        </data-row>
        <data-row title="Date of Birth">{{ user.dob | moment('MMMM Do, YYYY') }}<br>{{ user.dob | moment('from', 'now', true) }} old</data-row>

        <data-row title="Grade Level">{{ user.grade_level }}</data-row>
        <data-row title="Subject">{{ user.subject_area }}</data-row>
        <data-row title="School">{{ user.school }}</data-row>
        <data-row title="District">{{ user.district }}</data-row>

        <data-row title="Referral">{{ user.referral }}</data-row>
        <data-row title="Assigned Reseller"></data-row>
        <data-row title="Registration Date">{{ user.created_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
        <data-row title="Last Login Date">{{ user.last_login_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
        <data-row title="User ID"><span class="is-clickable" @click="$copyText(user.id)">{{ user.id }}</span></data-row>

        <card-list :class="{'mb-3': user.enrollments.length === 0}">
            <subheader-list-item title="Enrollments" icon="fa-chalkboard-teacher" :badge="user.enrollments.length" />
            <course-enrollment-tile :enrollment="e" :card="card" v-for="e in user.enrollments" @click="$openCard('enrollment', {enrollId: e.id}, card)" />
        </card-list>
        <card-list :class="{'mb-3': user.classicEnrollments.length === 0}">
            <subheader-list-item title="Classic Enrollments" icon="fa-chalkboard-teacher" :badge="user.classicEnrollments.length" />
            <course-classic-enrollment-tile :enrollment="e" :card="card" v-for="e in user.classicEnrollments" />
        </card-list>

        <card-list :class="{'mb-3': user.registrations.length === 0}">
            <subheader-list-item title="Registrations" icon="fa-presentation" :badge="user.registrations.length" />
            <user-registration-tile :registration="r" :card="card" v-for="r in user.registrations" @click="$openCard('registration', {regId: r.id, confId: r.conference_id}, card)" />
        </card-list>

        <card-list :class="{'mb-3': user.payment_plans.length === 0}">
            <subheader-list-item title="Payment Plans" icon="fa-money-check-alt" :badge="user.payment_plans.length" />
            <plan-tile :plan="p" :card="card" v-for="p in user.payment_plans" @click="$openCard('payment-plan', {planId: p.id}, card)" />
        </card-list>

        <card-list :class="{'mb-3': user.user_certification.length === 0}">
            <subheader-list-item title="Certifications" icon="fa-certificate" :badge="user.user_certification.length" />
            <card-list-item v-for="cert in user.user_certification">
                <template v-slot:icon><i class="far fa-certificate fa-fw"></i></template>
                <template v-slot:content>
                    <div class="tile-title">{{cert.certifications.title}}</div>
                    <div class="meta mt-1"><i class="fas fa-barcode mr-2 fa-fw"></i>{{cert.certification_number}}</div>
                </template>
            </card-list-item>
        </card-list>

        <card-list :class="{'mb-3': user.user_certs.length === 0}">
            <subheader-list-item title="Certificates" icon="fa-file-certificate" :badge="user.user_certs.length" />
            <card-list-item v-for="cert in user.user_certs">
                <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                <template v-slot:content>
                    <div class="tile-title">{{cert.certification_certs.title}}</div>
                    <div class="meta mt-1"><i class="fas fa-barcode mr-2 fa-fw"></i>{{cert.last_awarded_at | moment('MMMM Do, YYYY')}}</div>
                </template>
            </card-list-item>
        </card-list>

    </div>

</template>

<script>
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import DataRow from "../../TIER/components/DataRow.vue";
    import CardList from "../../TIER/components/CardList.vue";
    import CourseEnrollmentTile from "../../components/tiles/CourseEnrollmentTile.vue";
    import UserRegistrationTile from "../../components/tiles/UserRegistrationTile.vue";
    import CourseClassicEnrollmentTile from "../../components/tiles/CourseClassicEnrollmentTile.vue";
    import PlanTile from "../../components/tiles/PlanTile.vue";
    import CardListItem from "../../TIER/components/CardListItem.vue";

    export default {
        name: 'MergeUserDetails',
        components: {CardListItem, PlanTile, CourseClassicEnrollmentTile, UserRegistrationTile, CourseEnrollmentTile, CardList, DataRow, SubheaderListItem},
        props: ['user','card']
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
